import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { revalidate } from '@/services/revalidate/revalidate';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

const useUpdateLocationStatus = () => {
  const queryClient = useQueryClient();
  const { mutateAsync: mutateAsyncLocationStatus } = useMutation('updateLocationStatus', {
    onSuccess: async (res) => {
      await queryClient.invalidateQueries({ queryKey: ['locations'] });
      await revalidate(['locations', 'all']);
      toast.success(res.message);
    },
    onError: (error) => {
      toast.error(error.message);
    },
  });

  return { mutateAsyncLocationStatus };
};

export default useUpdateLocationStatus;
